// import checkout from "../views/Checkout-process.vue";
import store from "../../../store";
import SellerShippingLogistics from "../components/SellerShippingLogistics.vue";
const checkout = () => import('../views/Checkout-process.vue');
const invoice = () => import('../views/invoice.vue');
import Confirmation from "../components/steps/Confirmation.vue"
import CheckoutGeneralFunctions from "../helpers/CheckoutGeneralFunctions"

export default [{
        path: "/checkout/:id?",
        name: "checkout",
        component: checkout,
        beforeEnter: async () => {
            // const {getOrCreateOrder,loadCartItemsFromCookie} = CheckoutGeneralFunctions()
            // getOrCreateOrder()
            // loadCartItemsFromCookie()
            // <script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCesypEBJ5FruuIgJUF9PiiNJC1cB-Udag&libraries=places&callback=initMap"></script>
            // const gMaps = document.getElementById('gMaps')
            // if (!gMaps)
            // {
            //     await new Promise(
            //         (resolve)=>
            //         {
            //             let googleMapsTag = document.createElement("script");
            //             googleMapsTag.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCesypEBJ5FruuIgJUF9PiiNJC1cB-Udag&libraries=places&callback=initMap";
            //             googleMapsTag.id = 'gMaps'
            //             document.getElementsByTagName("head")[0].appendChild(googleMapsTag);
            //             googleMapsTag.onload = function(){
            //                 resolve()
            //             }
            //         }
            //     )
                
            // }
            
        },
        params: { payment: false },
        
    },
    {
        path: "/checkout/payment",
        name: "checkoutPayment",
        component: checkout,
    },
    {
        path: "/checkout/seller-shipping-logistics/:order_kit_id",
        name: "sellerShippingLogistics",
        component: SellerShippingLogistics,
    },
    {
        path: "/invoice/:id",
        name: "invoice",
        component: invoice,
    },
];